<template>
  <v-app-bar
    app
    color="white"
    clipped-right
    clipped-left
    flat
    class="elevation-1"
  >
    <!-- Opción de menú de páginas -->
    <v-btn v-if="isAdmin()" icon @click="toggleLeftMenu">
      <v-icon>mdi-menu</v-icon>
    </v-btn>

    <v-img
      :style="'cursor:pointer'"
      @click="goToPage('/')"
      contain
      max-height="30"
      max-width="90"
      src="@/assets/complete_logo.png"
    />

    <!-- Botones de edición y guardado -->
    <template v-if="isAdmin()">
      <v-btn @click="updateEditing" class="ml-5">
        <v-icon v-if="editing">mdi-play-circle-outline</v-icon>
        <v-icon v-else>mdi-stop-circle-outline</v-icon>
      </v-btn>
      <v-btn @click="save"> Guardar </v-btn>
    </template>

    <v-spacer></v-spacer>

    <template v-if="!isLaboratory()">
      <v-btn v-if="has_history" class="mt-1 mr-2 elevation-1" @click="goToPage('history')">
        <v-icon>mdi-history</v-icon>
      </v-btn>
      <v-btn v-if="connection" class="mt-1 mr-2 elevation-1" @click="resetAlarms">
        <v-icon>mdi-sync-alert</v-icon>
      </v-btn>
      <!-- <v-btn class="mt-1 mr-2 elevation-1" @click="goToPage('alarms')">
        <v-icon>mdi-alert</v-icon>
      </v-btn> -->
    </template>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn class="mt-1 elevation-1" v-on="on" @click="logoutFromApp">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </template>
      <span>Cerrar Sesión</span>
    </v-tooltip>

    <!-- Modal de carga -->
    <v-dialog v-model="loading" persistent width="300">
      <v-card class="text-center pa-4">
        <v-progress-circular indeterminate color="primary" class="mb-4"></v-progress-circular>
        <span>Guardando, por favor espera...</span>
      </v-card>
    </v-dialog>

    <!-- Alerta de éxito -->
    <v-alert
      v-if="showSuccessAlert"
      type="success"
      class="fixed-top text-center"
      dismissible
      elevation="2"
    >
      Datos guardados correctamente.
    </v-alert>
  </v-app-bar>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      loading: false, // Controla la visibilidad del modal de carga
      showSuccessAlert: false, // Controla la visibilidad del v-alert
    };
  },
  computed: {
    ...mapState(["editing", "pages", "selectedPage"]),

    connection() {
      return this.actualPage()?.global_item_list.find((gi) => gi.settings.component_type == "koiote-snap7-connection");
    },

    //cuando se añadan otros posibles historicos modificar
    has_history() {
      return (
        this.$route.path == "/history" ? false : true
        // this.$route.path == "/history" ||
        // this.actualPage()
        //   ?.global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
        //   ?.customized?.vartable?.some((v) => v?.seconds > 0)
      );
    },

    writeTopic() {
      return this.connection?.customized.topic_write;
    },
  },
  methods: {
    ...mapGetters(["actualPage", "isAdmin", "isLaboratory"]),
    ...mapActions(["updateEditing", "changeShowLeftMenu", "logout", "setSelectedPageToHome", "postData", "loadPages"]),
    ...mapActions("nodered", ["doPublish"]),

    toggleLeftMenu() {
      this.changeShowLeftMenu();
    },

    async save() {
      this.loading = true; // Mostrar el modal de carga
      try {
        for (const page of this.pages) {
          const pageToStore = JSON.parse(JSON.stringify(page));
          pageToStore.item_list.forEach((item) => {
            if (item.customized?.data) {
              item.customized.data = [];
            }
          });
          pageToStore?.global_item_list
            ?.filter((gi) => gi.settings.component_type.includes("connection"))
            .forEach((c) => {
              (c.customized?.vartable || []).forEach((v) => {
                v.value = "";
              });
            });
          await this.postData({ path: "pages", body: pageToStore });
        }
        this.loadPages();
        this.showSuccessAlert = true; // Mostrar la alerta de éxito
        setTimeout(() => {
          this.showSuccessAlert = false; // Ocultar la alerta después de 5 segundos
        }, 5000);
      } catch (error) {
        console.error("Error al guardar:", error);
      } finally {
        this.loading = false; // Ocultar el modal de carga
      }
    },

    resetAlarms() {
      const formattedResetAddress = this.connection.customized.vartable.find(
        (v) => v.formatted_address == this.connection.customized.reset_address
      )?.address;

      this.doPublish({
        topic: this.writeTopic,
        message: {
          address: formattedResetAddress,
          value: true,
        },
      });
    },

    goToPage(goToPageName) {
      if (goToPageName == "/") this.setSelectedPageToHome();
      if (this.$route.path != goToPageName) {
        // if (goToPageName == "history") goToPageName = goToPageName + "/" + this.selectedPage;
        this.$router.push(goToPageName);
      }
    },

    logoutFromApp() {
      this.logout();
      location.reload(true);
      this.$router.push(`login`).catch(() => {}); //Si hay cambios sin guardar se cancela el cambio de ruta
    },
  },
};
</script>

<style>
.fixed-top {
  position: fixed;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2000;
}
</style>
